import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Card,
  CardBody,
  MenuItem,
  useDisclosure,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { EventCreateDataEditDrawer } from "features/admin/events/EventCreateDataEditDrawer";
import { useCustomerEventJsonRecordDataRetrieveSuspense } from "gen/endpoints/customer-event/customer-event";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PageMenu } from "shared/components/layout/PageMenu";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";

export const EventCreateDataTab: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const { customerEventId } = useRequiredStringParams();
  const styles = useMultiStyleConfig("PageHeader", { size: "lg" });
  const { data: customerEventCreateData, refetch } =
    useCustomerEventJsonRecordDataRetrieveSuspense(customerEventId);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const onCloseComplete = useCallback(async () => {
    onClose();
    await refetch();
  }, [onClose, refetch]);

  return (
    <PageTabBody>
      {customerEventCreateData.data_json ? (
        <>
          <Box
            className="mb-page-header__actions"
            sx={styles.actions}
            justifyContent="flex-end"
            marginBottom={4}
          >
            <PageMenu>
              <MenuItem onClick={onOpen}>{t("common:edit")}</MenuItem>
            </PageMenu>
          </Box>
          <Card>
            <CardBody display="inline-block" whiteSpace="pre">
              {JSON.stringify(
                JSON.parse(customerEventCreateData.data_json),
                null,
                2,
              )}
            </CardBody>
          </Card>
        </>
      ) : (
        <Alert status="info" mb={4} data-ls-enabled={true} data-public={true}>
          <AlertIcon>
            <InfoCircleIcon />
          </AlertIcon>
          <AlertTitle>{t("common:error.notFound")}</AlertTitle>
          <AlertDescription>
            Event create data is only persisted when performing a refresh or
            rollback. Check here again after performing one of those actions.
          </AlertDescription>
        </Alert>
      )}
      {isOpen && (
        <EventCreateDataEditDrawer
          onCloseComplete={onCloseComplete}
          customerEventId={customerEventId}
          customerEventCreateData={customerEventCreateData}
        />
      )}
    </PageTabBody>
  );
};
